import { Loader2, Share2 } from "lucide-react";
import { useBrands } from "../lib/brand";
import { IgConnect } from "../components/BrandConnections";
import { SocialConnections } from "../components/SocialConnections";

/**
 * Workspace "Koneksi" page — lets brand + manajer users (and admins in the
 * workspace) connect the active brand's social platforms (Instagram + the
 * generic platforms: Threads, Facebook, TikTok, Bluesky, …). WordPress stays
 * admin-managed because it rides the admin-only brand-config endpoint.
 */
export function Connections() {
  const { active, loading } = useBrands();

  if (loading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-teal" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="flex items-center gap-2 text-2xl font-bold tracking-tight text-navy">
          <Share2 className="h-6 w-6 text-teal" />
          Koneksi Sosmed
        </h1>
        <p className="text-sm text-slate-500">
          Hubungkan akun media sosial brand ini agar konten bisa dipublikasikan.
        </p>
      </div>

      {active ? (
        <div className="space-y-4">
          <IgConnect account={active} />
          <SocialConnections brand={active} />
        </div>
      ) : (
        <p className="text-sm text-slate-500">Belum ada brand aktif.</p>
      )}
    </div>
  );
}
